// extracted by mini-css-extract-plugin
export default {"item":"QuestionButton_item__h6gf5","wrapper":"QuestionButton_wrapper__oIqLw","button":"QuestionButton_button__C0tU1","arrow":"QuestionButton_arrow__xvWVT"};